import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import './ErrorPage.scss';
import ErrorIcon from './Images/error.svg';
import {saveToHistory} from '../../FuntoneSlice';

const ErrorPage = ({
    errorTitle = "אירעה שגיאה",
    errorMessage = "מצטערים, משהו השתבש. אנא נסה שוב מאוחר יותר.",
    shouldSaveToHistory = true,
                   }) => {
    const dispatch = useDispatch();

    // Save to history on mount
    useEffect(() => {
        if (shouldSaveToHistory) {
            dispatch(saveToHistory('error'));
        }
    }, [dispatch, shouldSaveToHistory]);

    return (
        <div className={'error-page'}>
            <Image className={'error-icon'} src={ErrorIcon} alt={"Notice"} />
            <span className="error-title">{errorTitle}</span>
            <span className="error-message">{errorMessage}</span>
        </div>
    );
};

export default ErrorPage;
